import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSharedState } from '../waxplorer/Waxplorer'
import { dateToUtc } from '../helpers/Dates'
import { get } from '../helpers/Api'
import Link from '../common/util/input/Link'
import cn from 'classnames'
import { DropTeaser } from '../dropteaser/DropTeaser'
import { Skeleton } from '@nextui-org/react'

export const DropSlider = ({
    title,
    href,
    market = 'nfthivedrops',
    highlight = false,
    limit = 24,
    isHome = false,
    orderBy = 'date_desc',
    upcoming = false,
    nextButtonClass = '',
    prevButtonClass = '',
    nextClassName = '',
    prevClassName = '',
}) => {
    const [drops, setDrops] = useState([])
    const swiperElRef = useRef(null)
    const [isDragging, setIsDragging] = useState(false)

    const [state] = useSharedState()

    const activeUser = state?.activeUser

    const userName = activeUser?.accountName
        ? state?.activeUser.accountName
        : null

    const parseDrops = (res) => {
        let dropIdStartTimes = []
        for (const drop of res) {
            let dropStartDate
            if ('startTime' in drop) {
                dropStartDate = dateToUtc(new Date(drop.startTime * 1000))
            } else {
                dropStartDate = new Date(drop.timestamp * 1000)
            }
            dropIdStartTimes.push({
                dropId: drop.dropId,
                dropStartDate: dropStartDate,
            })
        }
        dropIdStartTimes = dropIdStartTimes.slice(0, limit)
        const relevantDropIds = dropIdStartTimes.map((drop) => drop.dropId)
        const drops = []
        for (const sortedDrop of relevantDropIds) {
            for (const unsortedDrop of res) {
                if (sortedDrop === unsortedDrop.dropId) {
                    drops.push(unsortedDrop)
                    break
                }
            }
        }
        setDrops(drops)
    }

    const getDrops = (userName) => {
        get(
            `drops?market=${market}&limit=${limit}&verified=verified&home=${isHome}&highlight=${highlight}&upcoming=${upcoming}&order_by=${orderBy}${
                userName ? '&user=' + userName : ''
            }`, 'wax-api'
        ).then(parseDrops)
    }

    useEffect(() => {
        if (typeof window !== 'undefined') {
            getDrops(userName)
        }
    }, [userName])

    return !drops || drops.length > 0 ? (
        <>
            <div className="max-w-min whitespace-nowrap">
                <Link href={href}>
                    <div
                        className={cn(
                            'font-semibold text-black dark:!text-white text-3xl text-left p-2 lg:py-5 mb-4 lg:mb-0',
                        )}
                    >
                        {title}
                    </div>
                </Link>
            </div>

            <div className={'max-w-full relative mb-4'}>
                <div className={' w-full h-auto gap-8 mx-2 md:mx-8'}>
                    <button
                        className={`${prevButtonClass} !bg-primary !rounded-full !p-2 absolute left-0 z-[9999] top-[140px]`}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="3"
                            stroke="currentColor"
                            className="w-6 h-6  "
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M15.75 19.5 8.25 12l7.5-7.5"
                            />
                        </svg>
                    </button>

                    <button
                        className={`${nextButtonClass} !bg-primary !rounded-full !p-2 absolute right-0 z-[9999] top-[140px]`}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="3"
                            stroke="currentColor"
                            className="w-6 h-6  "
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="m8.25 4.5 7.5 7.5-7.5 7.5"
                            />
                        </svg>
                    </button>
                    <swiper-container
                        ref={swiperElRef}
                        space-between="20"
                        slides-per-view="auto"
                        navigation="true"
                        pagination="false"
                        navigation-next-el={nextClassName}
                        navigation-prev-el={prevClassName}
                    >
                        {drops && drops.length > 0 ? (
                            drops.map((drop, index) => (
                                <swiper-slide>
                                    <DropTeaser
                                        drop={drop}
                                        index={index}
                                        isHome={isHome}
                                        isBeingDragged={isDragging}
                                    />
                                </swiper-slide>
                            ))
                        ) : !drops ? (
                            <div className="flex space-x-5">
                                {Array.from(new Array(24)).map(() => (
                                    <Skeleton className="min-w-[280px] h-[391px] rounded-lg">
                                        <div className="h-24 rounded-lg bg-default-300"></div>
                                    </Skeleton>
                                ))}
                            </div>
                        ) : (
                            ''
                        )}
                    </swiper-container>
                </div>
            </div>
        </>
    ) : (
        <></>
    )
}
